import { render } from "./HoldingSuccess.vue?vue&type=template&id=1324d38f&scoped=true"
import script from "./HoldingSuccess.vue?vue&type=script&lang=js"
export * from "./HoldingSuccess.vue?vue&type=script&lang=js"

import "./HoldingSuccess.vue?vue&type=style&index=0&id=1324d38f&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1324d38f"]])

export default __exports__